import {
  TContactAccessState,
  TContactRegisterState,
  TVerificationPayload,
  TRegisterUserPayload,
  TVerificationResendPayload,
  TReLoginPayload,
  TSendVerificationCodePayload,
  TVerificationV2Payload,
} from '@/api/types'

export const contactIdKey = 'contactId'
export const tokenKey = 'token'
export const emailKey = 'email'
export const tokenHeader = 'x-bgv-token'

export type IUser = {
  contactId: string
  token: string
}

export type TSignupResult = {
  contactId: string
  state?: TContactRegisterState
  user?: IUser
  appCountryTier?: string
}

export type TReLoginResult = {
  state?: TContactAccessState
}

export type TVerificationResult = {
  user: IUser
  state?: TContactAccessState
  appCountryTier?: string
}

export type TVerificationV2Result = {
  user: IUser
  state?: TContactAccessState
  appCountryTier?: string
}

export interface IAuthContext {
  user: IUser | null
  signup: (payload: TRegisterUserPayload) => Promise<TSignupResult>
  login: (contactId: string, payload: TVerificationPayload) => Promise<TVerificationResult>
  loginV2: (ayload: TVerificationV2Payload) => Promise<TVerificationV2Result>
  relogin: (payload: TReLoginPayload) => Promise<TReLoginResult>
  sendVerificationCode: (payload: TSendVerificationCodePayload) => Promise<void>
  resendVerificationCode: (contactId: string, payload: TVerificationResendPayload) => Promise<void>
  refreshUser: () => Promise<IUser>
  logout: () => Promise<void>
  authUser: (contactId: string, token: string, email: string | undefined | null) => IUser
}
